export default "<div class=\"station-status\" [style.border-color]=\"color\" matTooltip=\"{{status}}\"></div>\n";